import React, { Fragment } from 'react';
import lateFee from '../../../../images/charge-speed.png';

const ChargingTime = () => (
  <Fragment>
    <p>
      Charging times for the Tesla differ based on the current charge level
      and charging station output. We recommend using Tesla Supercharging
      stations for the fastest charging session. However, you can also
      choose to charge the Tesla at any third-party charging station.
    </p>
    <br />
    <p>Below is data on the performance of a Tesla Supercharger</p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img
        src={lateFee}
        style={{
          height: window.innerWidth < 768 ? '225px' : '380px',
          width: window.innerWidth < 768 ? '350px' : '600px'
        }}
      />
    </div>
    <br />
    <ol>
      <li>Tesla Superchargers: Up to 320km added in just 15 minutes.</li>
      <li>Level 2 (240V): Partial to full charge in 5-8 hours.</li>
    </ol>
  </Fragment>
);

export default ChargingTime;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/ChargingTime.js